/**
 * Native-submit fallback for the auth forms.
 *
 * Auth forms set `method="post"` and point `action` at
 * `/api/auth/form-fallback`, so a submit that happens before React attaches
 * `onSubmit` (slow hydration, password-manager `form.submit()`) can never
 * serialize credentials into the URL. The route discards the body and
 * redirects back to the originating auth page.
 */

import type { AuthPagePath } from "@/lib/constants/auth";

export const AUTH_FORM_FALLBACK_PATH = "/api/auth/form-fallback";

export interface AuthFormFallbackParams {
  readonly callbackUrl?: string | null;
  readonly token?: string | null;
}

export function buildAuthFormFallbackAction(
  to: AuthPagePath,
  { callbackUrl, token }: AuthFormFallbackParams = {},
): string {
  const params = new URLSearchParams({ to });
  if (callbackUrl) params.set("callbackUrl", callbackUrl);
  if (token) params.set("token", token);
  return `${AUTH_FORM_FALLBACK_PATH}?${params.toString()}`;
}
